import { DividingLineIcon } from "components/icons";

interface IManualCard {
  videoUrl: string;
  description?: string;
}
export const ManualCard = ({ videoUrl, description }: IManualCard) => {
  if (!videoUrl && !description) return null;
  const formatUrl = (url: string): string => {
    const ids = url.substring(url.indexOf("?v=") + 3);
    const newVideoUrl = `https://www.youtube.com/embed/${ids}`;
    return newVideoUrl;
  };
  return (
    <div className="flex flex-col items-center justify-center py-4">
      {videoUrl && (
        <iframe
          className="w-full max-w-[360px] h-[188px] bg-page rounded"
          src={formatUrl(videoUrl)}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      )}
      {description && <p className="pt-3 pb-4 break-all">{description}</p>}
      <DividingLineIcon />
    </div>
  );
};
